import { MANUFACTURER_IDS } from "./manufacturers.js";
import type { Manufacturer } from "../schema/common.js";

export interface CollectionMilestone {
  id: string;
  name: { de: string; en: string };
  /** Either a total count of owned units or every unit of one manufacturer. */
  requirement: { kind: "count"; count: number } | { kind: "manufacturer"; mfr: Manufacturer };
  reward: { items: { itemId: string; qty: number }[]; credits: number };
}

const MFR_NAMES: Record<Manufacturer, string> = { HEX: "Hexa Dynamics", KRG: "Kurogane Works", VLK: "Valkyr Systems", OMC: "Orbital Mind Collective", RDL: "Redline Foundry" };

/** Collection milestones (30-units.md R29): counts and one-of-each-manufacturer sets. */
export const COLLECTION_MILESTONES: readonly CollectionMilestone[] = [
  { id: "col.own10", name: { de: "Zehn Frames", en: "Ten Frames" }, requirement: { kind: "count", count: 10 }, reward: { items: [{ itemId: "itm.cdc", qty: 50 }, { itemId: "itm.fab", qty: 1 }], credits: 20 } },
  { id: "col.own20", name: { de: "Zwanzig Frames", en: "Twenty Frames" }, requirement: { kind: "count", count: 20 }, reward: { items: [{ itemId: "itm.cdc", qty: 100 }, { itemId: "itm.fab", qty: 3 }], credits: 50 } },
  { id: "col.own30", name: { de: "Dreißig Frames", en: "Thirty Frames" }, requirement: { kind: "count", count: 30 }, reward: { items: [{ itemId: "itm.cdc", qty: 200 }, { itemId: "itm.fab", qty: 5 }, { itemId: "itm.ufr_a", qty: 20 }], credits: 100 } },
  { id: "col.own45", name: { de: "Die ganze Flotte", en: "The Whole Fleet" }, requirement: { kind: "count", count: 45 }, reward: { items: [{ itemId: "itm.cdc", qty: 500 }, { itemId: "itm.ffab", qty: 10 }, { itemId: "itm.ufr_s", qty: 30 }], credits: 500 } },
  ...MANUFACTURER_IDS.map((mfr): CollectionMilestone => ({
    id: `col.mfr_${mfr.toLowerCase()}`,
    name: { de: `Alle Frames von ${MFR_NAMES[mfr]}`, en: `Every ${MFR_NAMES[mfr]} frame` },
    requirement: { kind: "manufacturer", mfr },
    reward: { items: [{ itemId: "itm.cdc", qty: 50 }, { itemId: "itm.ufr_b", qty: 10 }], credits: 30 },
  })),
];

export function collectionMilestoneById(id: string): CollectionMilestone {
  const m = COLLECTION_MILESTONES.find((x) => x.id === id);
  if (!m) throw new Error(`unknown milestone ${id}`);
  return m;
}
